export type TeamMember = {
  id: string
  email: string
  roles: Array<{ name: string }>
  lastLoginAt: number
  firstName?: string
  lastName?: string
}

export enum TEAM_ACTIONS {
  SET_TEAM = 'TEAM_ACTIONS.SET_TEAM',
}

type SetTeam = {
  type: typeof TEAM_ACTIONS.SET_TEAM
  team: TeamMember[]
}

export type ActionTypes = SetTeam
